import React from "react";
import { useTranslation } from "react-i18next";
import { GoalClockIcon } from "@/apps/goals/assets/icons";
import { GoalHeroStripes } from "@/apps/goals/components/GoalHeroStripes/GoalHeroStripes";
import { GoToParkButton } from "@/apps/goals/components/NextGoalButton/GoToParkButton";
import { GoalProgressBlock } from "@/apps/goals/components/GoalProgressBlock/GoalProgressBlock";
import { NextGoalCard } from "@/apps/goals/components/NextGoalCard/NextGoalCard";
import { useCurrentGoalData } from "@/apps/goals/hooks/useCurrentGoalData";
import { useGoalParkTitle } from "@/apps/goals/hooks/useGoalParkTitle";
import Typography from "@/ui/Typography/Typography";
import cls from "./styles.module.scss";

export const GoalFailedPage = () => {
  const { t } = useTranslation();
  const goalParkTitle = useGoalParkTitle();
  const { ridesRequired, completedRides, expiresAt } = useCurrentGoalData();

  return (
    <section className={cls.root}>
      <div className={cls.content}>
        <div className={cls.hero}>
          <GoalHeroStripes />
          <img className={cls.targetIcon} src="/goals/target.png" alt="" />
        </div>
        <div className={cls.timeBadge}>
          <GoalClockIcon />
          <Typography component="span" size="sm" weight="medium" family="Onest">
            {t("goals.failed.timeExpired")}
          </Typography>
        </div>
        <div className={cls.copy}>
          <Typography component="p" size="md" weight="bold">
            {goalParkTitle}
          </Typography>
          <Typography
            className={cls.goal}
            component="h1"
            size="2xl"
            weight="semibold"
            family="custom"
          >
            {t("goals.failed.goalNotCompleted")}
          </Typography>
        </div>
        <GoalProgressBlock
          completedRides={completedRides}
          ridesRequired={ridesRequired}
          variant="failed"
        />
        <NextGoalCard startsAt={expiresAt} />
        <GoToParkButton />
      </div>
    </section>
  );
};
